import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  DialogActions,
  Grid,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  FormGroup,
  Switch,
  Box,
  SwipeableDrawer,
} from "@material-ui/core";
import CustomInput from "../../../../../Components/CustomInput";
import DateComponent from "../../../../../Components/FormGenerator/datepicker_component";
import DataService from "../../../../../Service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import CloseIcon from "@material-ui/icons/Close";
const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
  },
  errorLog: {
    color: "#ff0000",
  },
  title: {
    textTransform: "none",
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "97%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #3B86FF",
    },
  },
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  fieldsFilter: {
    width: 400,
    marginTop: "70px",
    padding: "10px",
  },
  fieldsFormTitle: {
    display: "flex",
    alignItems: "center",
  },
}));

const ActivityLogToggleModal = (props) => {
  const {
    isOpen,
    onClose,
    setNewInputState,
    activityData,
    errorLogs,
    onsubmit,
    selection,
  } = props;

  console.log(props, "toggle props");
  const classes = useStyles();

  const [fieldsData, setFieldsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [selection.id]);

  const dispatch = useDispatch();

  const fetchData = () => {
    setIsLoading(true);
    const params = { programme_id: selection.id };
    DataService.getDirectData("/activity_logs/show_mini_mi_fields", params)
      .then((res) => {
        setFieldsData(res?.mini_mi_fields);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (e, selectedField, type) => {
    console.log(selectedField, "selected field");
    setFieldsData((prev) => {
      const localArr = [...prev].map((option) => {
        if (selectedField?.id === option?.id) {
          option["is_active"] = e.target.checked;
        }
        return option;
      });
      return localArr;
    });
    const formData = {};
    formData["is_active"] = `${selectedField.is_active}`;
    formData["programme_id"] = selection.id;
    formData["activity_log_id"] = selectedField.id;
    console.log(formData, "form data");

    DataService.updateData(formData, null, "activityLogProgramToggle")
      .then((res) => {
        if (res?.success) {
          dispatch(showSnackbar("Success", ["" + res.message], 1000));
        }
      })
      .catch((error) => {});
  };

  const List = () => {
    return (
      <Box m={3} className={classes.fieldsFilter}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 15,
          }}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontSize: "18px",
              fontFamily: "Open Sans",
              zIndex: 2,
            }}
          >
            Manage activity log - {selection?.name}
          </Typography>
          <CloseIcon
            onClick={() => onClose()}
            style={{ fontSize: 18, cursor: "pointer" }}
          />
        </Box>
        <Grid container spacing={2} style={{ marginBottom: "0.5rem" }}>
          <Grid item xs={8}>
            <Typography
              variant="subtitle1"
              style={{ fontSize: "16px" }}
              color="secondary"
            >
              Activity name
            </Typography>
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        <FormControl
          component="fieldset"
          style={{ display: "flex", fontSize: "16px", fontFamily: "Open Sans" }}
        >
          {isLoading ? (
            <Box
              style={{
                width: "100%",
                height: "50vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <FormGroup>
              {fieldsData?.map((option) => {
                return (
                  <Grid container spacing={4} style={{ marginBottom: "-10px" }}>
                    <Grid item xs={8} className={classes.fieldsFormTitle}>
                      <label style={{ fontSize: "16px" }}>
                        {option.activity_name}
                      </label>
                    </Grid>

                    <Grid item xs={2}>
                      <FormControlLabel
                        label={""}
                        style={{ alignSelf: "flex-end" }}
                        control={
                          <Switch
                            checked={option.is_active}
                            onChange={(e) => {
                              handleChange(e, option);
                            }}
                            name={`${option.name}-client`}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </FormGroup>
          )}
        </FormControl>
      </Box>
    );
  };

  return (
    <>
      <div>
        <React.Fragment>
          <SwipeableDrawer
            anchor={"right"}
            open={isOpen}
            onClose={() => onClose()}
          >
            <List />
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
};
export default ActivityLogToggleModal;
